module.exports = __webpack_public_path__ + "files/1f304baa786f1673e274e07c11d81db9.png";